<template>
  <v-row>
    <v-col cols="12" xl="4">
      <ChartCard
        id="actionsWebsiteConversion"
        :chart="charts.clicksConversion"
        :infoIconColor="infoIconColor"
        :tooltipMaxWidth="tooltipMaxWidth"
        :totalViews="totalViews"
        :is-date-in-range="isDateInRange"
        :title="
          $t(
            'message.analytics.businessAddresses.chart.clicksConversion.title.text'
          )
        "
        :tooltip="
          $t(
            'message.analytics.businessAddresses.chart.clicksConversion.title.tooltip'
          )
        "
      />
    </v-col>
    <v-col cols="12" xl="4">
      <ChartCard
        id="actionsDrivingDirectionsConversion"
        :chart="charts.directionsConversion"
        :infoIconColor="infoIconColor"
        :tooltipMaxWidth="tooltipMaxWidth"
        :totalViews="totalViews"
        :is-date-in-range="isDateInRange"
        :title="
          $t(
            'message.analytics.businessAddresses.chart.directionsConversion.title.text'
          )
        "
        :tooltip="
          $t(
            'message.analytics.businessAddresses.chart.directionsConversion.title.tooltip'
          )
        "
      />
    </v-col>
    <v-col cols="12" xl="4">
      <ChartCard
        id="actionsPhoneConversion"
        :chart="charts.callsConversion"
        :infoIconColor="infoIconColor"
        :tooltipMaxWidth="tooltipMaxWidth"
        :is-date-in-range="isDateInRange"
        :totalViews="totalViews"
        :title="
          $t(
            'message.analytics.businessAddresses.chart.callsConversion.title.text'
          )
        "
        :tooltip="
          $t(
            'message.analytics.businessAddresses.chart.callsConversion.title.tooltip'
          )
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import ChartCard from "./ConversionChartCard.vue";

export default {
  name: "ConversionCharts",
  components: {
    ChartCard
  },
  props: {
    isDateInRange: {
      type: Boolean,
      default: true
    },
    charts: {
      type: Object,
      required: true
    },
    infoIconColor: {
      type: String,
      default: "primary"
    },
    tooltipMaxWidth: {
      type: Number,
      default: 500
    }
  },
  computed: {
    totalViews() {
      return this.charts.maps.relatedChartsData
        .map(relatedChartData => relatedChartData.sum)
        .reduce((a, b) => a + b, 0);
    }
  }
};
</script>
